export const BYTES_TO_MB = 1024 * 1024;

export const MAX_UPLOAD_SIZE_MB = 100;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * BYTES_TO_MB;
export const UPLOAD_TIMEOUT_SECONDS = 10 * 60; // 10 minutes
export const FILE_SIZE_ERROR_MESSAGE = `The selected file exceeds the size limit of ${MAX_UPLOAD_SIZE_MB}MB. Please choose a smaller file.`;

export const MAX_VIDEO_FILE_SIZE_BYTES = 1000 * BYTES_TO_MB;
